import {isInAccessibilityMode} from '../../../../selectors/seating/mode'
import {getPlaces, getPlacesInBasket, getSelectedPlace} from '../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {PlanOwnProps, PlanRuntimeProps} from './interfaces'
import {Plan as Presentation} from './plan'

const mapRuntime = ({
  state: {
    seating: {plan},
  },
  state,
  actions: {seatingMapButtonClick},
}: DetailsPageAppProps): PlanRuntimeProps => ({
  plan,
  selectedPlace: getSelectedPlace(state),
  placesInBasket: getPlacesInBasket(state),
  placesWithTicketInfo: getPlaces(state),
  showAccessibilityMode: isInAccessibilityMode(state),
  seatingMapButtonClick,
})

export const Plan = connect<PlanOwnProps, PlanRuntimeProps>(mapRuntime)(Presentation)
